<template>
  <iframe title="" :src="iframeUrl" width="100%" :height="iframeHeight" scrolling="no" allowTransparency="true" />
</template>

<script lang="ts">
import Vue from 'vue';
import { getValidReferrer } from '~/components/common/SignUpModal/utils';
import { REFERER_IS_JOB_POSTING_LINK } from '~/components/partials/jobs/constants';

type PossibleCallbacks = Record<string, (body: PostMessage['data']['body']) => void>;

type PostMessage = {
  data: {
    type: keyof PossibleCallbacks;
    body: string | object | number;
  };
  origin: string;
};

export default Vue.extend({
  name: 'LandingDomainPage',
  data() {
    return {
      iframeHeight: '100%',
    };
  },
  computed: {
    iframeUrl(): string {
      const { params } = this.$route;
      const [domain, ...pathForIframe] = params.pathMatch.split('/');
      return `https://${domain}.bravado.co/${pathForIframe.join('/')}`;
    },
    POSSIBLE_MESSAGES(): PossibleCallbacks {
      return {
        REDIRECT: body => {
          this.$router.push(body as string);
        },
        SEND_EVENT: body => {
          this.$analytics.logEvent(...(body as [string, Record<string, undefined>, () => void]));
        },
        SET_HEIGHT: body => {
          // Sometimes iframe start to show/hide scrollbar in a loop because of pixel precision
          const GAP = 10;
          this.iframeHeight = String(Number(body) + GAP);
        },
        SCROLL_TOP: body => window.scrollTo({ top: 0, behavior: body ? 'auto' : 'smooth' }),
      };
    },
  },
  watch: {
    // Check if the user is already logged in to redirect correctly
    '$route.query.referer': {
      handler() {
        const referer = (this.$route.query?.referer || '') as string;
        if (this.$auth.loggedIn && getValidReferrer(referer)) {
          window.location.href = referer;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    const { query } = this.$route;
    this.$3rdParty.loadImmediately(['tiktok', 'facebook']);
    window.addEventListener('message', this.handlePostMessage);

    if (document.referrer.includes('jobs.bravado.co') || document.referrer.includes('https://bravado.co/lp/jobs')) {
      this.$cookies.set(REFERER_IS_JOB_POSTING_LINK, true, {
        maxAge: 60 * 60 * 24 * 30, // 30 days expiry
        path: '/',
      });
    }

    if (query?.event) {
      this.$analytics.logEvent(query.event as string);
    }
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handlePostMessage);
  },
  methods: {
    handlePostMessage({ origin, data }: PostMessage): void {
      if (!this.iframeUrl.includes(origin)) return;
      const { type, body } = data;
      return this.POSSIBLE_MESSAGES[type]?.(body);
    },
  },
});
</script>

<style lang="scss" scoped>
iframe {
  border: 0;
  min-height: 100vh;
  margin-bottom: -16px;
  overflow: hidden;

  @include mq('sm') {
    min-height: calc(100vh - 80px);
  }
}
</style>
